var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.004 512.004",
    style: {
      enableBackground: "new 0 0 512.004 512.004"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75C0C7"
    },
    d: "M119.955,512.001v-55.095c0-18.189,14.745-32.934,32.934-32.934h63.098v16.005l40.014,24.008 l40.014-24.008v-16.004h63.098c18.189,0,32.934,14.745,32.934,32.934v55.095"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.968,
    y: 487.997,
    style: {
      fill: "#589095"
    },
    width: 19.684,
    height: 24.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.029,
    y: 487.997,
    style: {
      fill: "#589095"
    },
    width: 19.684,
    height: 24.008
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#589095"
    },
    d: "M200.947,424.268h-48.058c-18.189,0-32.933,14.449-32.933,32.638v55.095H168v-55.095 C168,438.718,182.758,424.268,200.947,424.268z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DCCD"
    },
    points: "296.013,439.977 256.001,463.986 215.987,439.977 215.987,391.962 296.013,391.962 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A8A59A"
    },
    points: "248.422,439.977 248.422,391.89 216.044,391.89 216.044,439.977 256.241,463.986  256.241,463.986 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BAF78"
    },
    d: "M175.974,143.879L175.974,143.879c-17.679,0-32.01,14.332-32.01,32.01v32.011 c0,17.679,14.332,32.01,32.01,32.01l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DCCD"
    },
    d: "M336.027,175.891h4.001c11.049,0,20.006,8.957,20.006,20.006l0,0 c0,11.049-8.957,20.006-20.006,20.006h-4.001V175.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBB3B"
    },
    d: "M296.467,63.935V47.848c0-22.098-18.113-40.014-40.211-40.014c-22.098,0-40.211,17.914-40.211,40.014 v7.732"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD8C2C"
    },
    d: "M240.067,55.579v-7.732c0-17.887,11.78-32.854,27.973-37.977c-3.812-1.206-7.782-2.036-11.993-2.036 c-22.098,0-40.002,17.914-40.002,40.014v7.732"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DCCD"
    },
    d: "M336.027,319.938c0,44.198-35.829,80.026-80.026,80.026l0,0c-44.198,0-80.026-35.829-80.026-80.026 V127.874c0-44.198,35.829-80.026,80.026-80.026l0,0c44.198,0,80.026,35.829,80.026,80.026V319.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8A59A"
    },
    d: "M231.711,319.938V127.874c0-34.328,21.797-63.522,52.159-74.887 c-8.729-3.267-17.879-5.14-27.748-5.14c-44.198,0-79.765,35.829-79.765,80.026v192.064c0,44.198,35.639,80.026,79.836,80.026 c9.869,0,19.044-1.873,27.773-5.14C253.603,383.46,231.711,354.266,231.711,319.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBB3B"
    },
    d: "M231.99,52.941c-6.945,14.297-9.757,30.973-6.886,48.475c6.392,38.961,41.92,66.472,81.401,66.472 l0,0c16.305,0,29.522,13.217,29.522,29.522v26.496v-90.933c0-42.938-34.171-78.078-77.092-79.279L231.99,52.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.733,352.201h16.272c17.679,0,31.772-14.458,31.772-32.138v-0.304 c0-17.679-14.093-32.314-31.772-32.314h-32.011c-17.679,0-32.307,14.572-32.307,32.251v0.12c0,9.565,4.209,18.336,10.859,24.202"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD8C2C"
    },
    d: "M257.179,101.416c-2.798-17.058-0.197-33.315,6.367-47.366c-1.523-0.131-3.048-0.312-4.595-0.355 l-26.952-0.754c-6.945,14.297-9.761,30.973-6.89,48.475c6.392,38.961,41.981,66.472,81.463,66.472 c16.305,0,29.584,13.217,29.584,29.522v-29.63C297.511,166.647,263.435,139.552,257.179,101.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD8C2C"
    },
    d: "M223.989,103.867L223.989,103.867c-26.518,0-48.016,21.498-48.016,48.016v8.003v-48.016 c0-30.939,25.08-56.019,56.019-56.019l0,0L223.989,103.867z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4BAF78"
    },
    cx: 239.992,
    cy: 343.947,
    r: 16.005
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.001,271.596c-13.144,0-23.838-10.261-23.838-23.838h15.667c0,4.178,3.666,8.172,8.172,8.172s8.172-3.994,8.172-8.172 h15.667C279.839,261.335,269.145,271.596,256.001,271.596z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 159.643,
    y: 487.976,
    width: 15.667,
    height: 24.022
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 336.154,
    y: 487.976,
    width: 15.667,
    height: 24.022
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 207.688,
    y: 175.687,
    width: 15.667,
    height: 32.378
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 288.11,
    y: 175.687,
    width: 15.667,
    height: 32.378
  })), /*#__PURE__*/React.createElement("rect", {
    x: 192.021,
    y: 135.998,
    style: {
      fill: "#FCBB3B"
    },
    width: 32.378,
    height: 15.667
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.849,120.335h-15.667c0-17.756-14.339-32.643-32.095-32.643V72.025 C290.2,72.025,311.849,93.179,311.849,120.335z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.111,416.139h-55.334v-22.524c24.102-15.683,40.083-42.84,40.083-73.676v-96.031v-0.44 c13.543-1.874,24.008-13.519,24.008-27.57s-10.464-25.696-24.008-27.57v-40.453c0-30.836-15.981-57.993-40.083-73.676v-6.35 C303.778,21.464,282.224,0,255.733,0s-48.044,21.464-48.044,47.847v6.693c-23.805,15.735-39.548,42.724-39.548,73.332v8.95 c-18.232,3.649-32.01,19.778-32.01,39.066v8.156h-7.819v15.667h7.819v8.188v80.026c0,25.125,14.592,46.898,35.741,57.314 c6.053,20.086,19.12,37.156,36.333,48.368l-0.037,22.53h-55.277c-22.479,0-40.767,18.288-40.767,40.768V512h15.667v-55.094 c0-13.84,11.26-25.101,25.1-25.101h55.265v12.607l40.269,24.161v19.406h15.667v-19.712l39.758-23.855v-12.606h55.265 c13.84,0,25.1,11.26,25.1,25.101v55.094h15.667v-55.094C399.879,434.427,381.591,416.139,359.111,416.139z M343.86,197.409v-13.059 c4.839,1.611,8.341,6.173,8.341,11.546s-3.503,9.936-8.341,11.546V197.409z M151.796,175.891c0-10.59,6.847-19.605,16.343-22.867 v6.862v70.883c-9.497-3.263-16.343-12.277-16.343-22.867V175.891z M151.796,287.927v-48.386c4.73,3.623,10.29,6.214,16.343,7.426 v72.971c0,1.409,0.041,2.81,0.107,4.203C158.174,315.303,151.796,302.35,151.796,287.927z M289.462,63.935 c23,12.086,38.731,36.204,38.731,63.939v39.15c-6.119-4.38-13.605-6.97-21.689-6.97c-36.397,0-68.068-25.754-73.671-59.906 c-2.396-14.604-0.485-29.18,5.504-42.273c5.655-1.428,11.57-2.193,17.663-2.193c11.532,0,22.432,2.732,32.11,7.561v0.694h1.352 V63.935z M255.733,15.668c17.263,0,31.411,13.497,32.329,30.431c-9.94-3.911-20.749-6.084-32.061-6.084 c-11.519,0-22.516,2.251-32.605,6.299C224.204,29.279,238.398,15.668,255.733,15.668z M218.918,65.961 c-2.536,9.885-3.33,20.196-2.332,30.578c-11.842,1.576-22.517,6.871-30.817,14.677C190.311,92.063,202.492,75.837,218.918,65.961z  M190.898,351.122c2.969,0.425,5.999,0.657,9.084,0.657h17.503c3.248,9.307,12.109,16.005,22.51,16.005 c7.198,0,13.656-3.212,18.031-8.272h13.98c22.096,0,40.079-17.766,40.128-39.622c0-0.015,0-0.029,0-0.044s0-0.029,0-0.044 c-0.048-21.881-18.031-39.668-40.128-39.668h-32.01c-21.841,0-39.612,17.86-39.618,39.813c0,0.001,0,0.003,0,0.005s0,0.003,0,0.005 c0.001,5.725,1.145,11.184,3.317,16.154h-3.713c-5.174,0-10.156-0.829-14.831-2.346c-0.872-4.479-1.343-9.099-1.343-13.829V159.886 v-8.003c0-20.629,15.628-37.669,35.665-39.922c4.805,16.869,14.876,32.041,29.017,43.407c16.33,13.124,36.934,20.353,58.017,20.353 c11.959,0,21.689,9.729,21.689,21.689v26.497v96.031c0,39.807-32.386,72.193-72.193,72.193 C227.355,392.131,202.555,375.36,190.898,351.122z M239.994,320.107c-8.876,0-16.628,4.88-20.731,12.093 c-2.101-3.613-3.219-7.793-3.22-12.247c0.003-13.318,10.746-24.152,23.951-24.152h32.01c13.472,0,24.436,10.783,24.461,24.045 c-0.024,13.237-10.989,23.999-24.461,23.999h-8.175C263.776,330.747,253.105,320.107,239.994,320.107z M248.167,343.946 c0,4.506-3.666,8.172-8.172,8.172c-4.506,0-8.172-3.666-8.172-8.172c0-4.506,3.666-8.172,8.172-8.172 C244.501,335.774,248.167,339.44,248.167,343.946z M256.001,454.85l-32.18-19.308l0.037-33.845 c9.96,3.931,20.801,6.101,32.144,6.101c11.331,0,22.157-2.18,32.11-6.104l0.069,33.848L256.001,454.85z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 248.421,
    y: 496.331,
    width: 15.667,
    height: 15.667
  })), /*#__PURE__*/React.createElement("rect", {
    x: 288.11,
    y: 487.976,
    style: {
      fill: "#FCBB3B"
    },
    width: 32.378,
    height: 15.667
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.80b6819aa288f29991543c541b32a8f9.svg";
export { ForwardRef as ReactComponent };